import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=acbe50fa&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"
import style0 from "./curd.vue?vue&type=style&index=0&id=acbe50fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbe50fa",
  null
  
)

export default component.exports